import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@/components/ui/tooltip";
import { ALLERGEN_MAP } from "@/lib/data";

export const AllergenBadges = ({ allergens = [] }) => {
  if (!allergens.length) return null;
  return (
    <TooltipProvider delayDuration={100}>
      <div className="flex flex-wrap items-center gap-1.5" data-testid="allergen-badges">
        {allergens.map((key) => {
          const a = ALLERGEN_MAP[key];
          if (!a) return null;
          const Icon = a.icon;
          return (
            <Tooltip key={key}>
              <TooltipTrigger asChild>
                <span
                  className="inline-flex h-6 w-6 items-center justify-center rounded-full ring-1 ring-black/5"
                  style={{ backgroundColor: `${a.color}1A`, color: a.color }}
                >
                  <Icon className="h-3.5 w-3.5" strokeWidth={2.2} />
                </span>
              </TooltipTrigger>
              <TooltipContent>{a.es}</TooltipContent>
            </Tooltip>
          );
        })}
      </div>
    </TooltipProvider>
  );
};
